import { ElementType, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentDto } from '@sib/api';
import { Button } from '@sib/ui';
import { NoResultsIcon, DownloadIcon } from '@spendbrain/icons';
import { downloadFile } from '@spendbrain/utils/files';

interface NoTableDataProps {
  Icon?: ElementType;
  title: string;
  description?: string;
  document?: DocumentDto;
}

export const NoTableData = ({
  Icon,
  title,
  description,
  document,
  children,
}: PropsWithChildren<NoTableDataProps>) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    if (document?.fileUrl) {
      downloadFile(document.fileUrl, document.name);
    }
  };

  return (
    <div className="flex size-full items-center justify-center overflow-hidden rounded">
      <div className="relative box-border flex size-full flex-col items-center justify-center gap-y-7 rounded-sm py-20">
        {Icon ? (
          <Icon className="text-primary size-32" />
        ) : (
          <NoResultsIcon className="text-primary size-32" aria-hidden="true" />
        )}
        <div className="flex w-full flex-col items-center gap-y-4">
          <h3 className="text-primary text-center text-3xl">{title}</h3>
          {description && (
            <p className="text-primary max-w-md text-center text-xl font-normal">
              {description}
            </p>
          )}
        </div>
        {document?.fileUrl && (
          <div className="mt-4">
            <Button
              onClick={handleDownload}
              className="inline-flex items-center gap-2"
            >
              <DownloadIcon className="size-4" />
              {t('download')}
            </Button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
